import React, { useState, useEffect } from 'react';
import { FaStarOfLife } from 'react-icons/fa';
import { Container } from '../styles';
import RModal from '../../../components/Rsuite/Modal';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomButton } from '../../../components/CustomButton';
import { NotificationManager } from 'react-notifications';
import api from '../../../services/api';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import { CustomInput } from '../../../components/CustomInput';

const EditarCadastarPagamento = ({
  modal,
  close,
  pagamento,
  bandeirasSelect,
  formasPagamento,
  setFormasPagamento,
  id_empresa,
}) => {
  const [ativo, setAtivo] = useState('');
  const [idPagamento, setIdPagamento] = useState('');
  const [taxaAdm, setTaxaAdm] = useState(0);
  const { theme } = useCustomTheme();

  const data = [
    { value: 1, label: 'Sim' },
    { value: 0, label: 'Não' },
  ].map((item) => ({ label: item.label, value: item.value }));

  const verificarExiste = (cartao) => {
    for (let i = 0; i < formasPagamento.length; i++) {
      if (+formasPagamento[i].IdPagamento === +cartao) {
        return true;
      }
    }
    return false;
  };

  const editarPagamento = async () => {
    if (id_empresa && idPagamento) {
      await api
        .patch(`forma-pagamento-empresa/alterar/${pagamento.Id}`, {
          IdPagamento: idPagamento,
          TaxaAdministracao: taxaAdm,
          Ativo: ativo,
        })
        .then((res) => {
          NotificationManager.info('Status alterado', 'Informação');
          setFormasPagamento((state) =>
            state.map((e) => {
              if (e.Id !== res.data.Id) {
                return e;
              }
              e = res.data;
              return e;
            }),
          );
          close();
        });
    } else {
      NotificationManager.error(
        'Preencha todos os campos obrigatórios',
        'Erro',
      );
    }
  };

  const cadastrarPagamento = async () => {
    if (!verificarExiste(idPagamento)) {
      if (idPagamento) {
        await api
          .post('forma-pagamento-empresa/criar', {
            IdEmpresa: id_empresa,
            IdPagamento: idPagamento,
          })
          .then((res) => {
            setFormasPagamento((state) => [...state, res.data]);
            close();
            NotificationManager.success(
              'Forma de pagamento cadastrada',
              'Sucesso',
            );
          })
          .catch((error) => console.log(error));
      } else {
        NotificationManager.error(
          'Preencha todos os campos obrigatórios',
          'Erro',
        );
      }
    } else {
      NotificationManager.error(
        'Forma de pagamento já se encontra cadastrada.',
        'Erro',
      );
    }
  };

  useEffect(() => {
    if (pagamento) {
      setIdPagamento(pagamento.IdPagamento);
      setAtivo(pagamento.Ativo);
      setTaxaAdm(pagamento.TaxaAdministracao);
    }
  }, [modal]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={pagamento ? `Editar Pagamento` : 'Cadastrar Pagamento'}
      footer={
        <>
          <CustomButton
            onClick={pagamento ? editarPagamento : cadastrarPagamento}
            appearance="primary"
          >
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      {!pagamento && (
        <form>
          <Container>
            <label htmlFor="nome">
              <b style={{ color: theme.colors.textSecondary }}>
                Forma de Pagamento <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </label>
            <CustomSelectPicker
              data={bandeirasSelect}
              onChange={setIdPagamento}
              placeholder="Selecione a bandeira"
              style={{ minWidth: '230px' }}
              menuMaxHeight={window.innerHeight / 3}
              searchable={false}
            />
          </Container>
        </form>
      )}
      {pagamento && (
        <div>
          <div>
            <span style={{ color: theme.colors.textSecondary }}>
              {pagamento.Descricao}
            </span>
          </div>
          <form>
            <Container>
              <label>
                <b style={{ color: theme.colors.textSecondary }}>
                  Taxa de Administração
                </b>
              </label>
              <CustomInput
                type="number"
                value={taxaAdm}
                min="0"
                onChange={setTaxaAdm}
              />
            </Container>
            <Container>
              <label htmlFor="ativo">
                {' '}
                <b style={{ color: theme.colors.textSecondary }}>Ativo</b>
              </label>
              <CustomSelectPicker
                data={data}
                onChange={setAtivo}
                defaultValue={pagamento.Ativo ? 1 : 0}
                searchable={false}
              />
            </Container>
          </form>
        </div>
      )}
    </RModal>
  );
};

export default EditarCadastarPagamento;
